export const INVOICE_SYSCODE = {
  Reserved: 0,
  Course: 1,
  Project: 2,
  Certification: 3,
  Tech_Support: 4,
  Membership: 5,
}

export const InvoiceSyscodeString = {
  [INVOICE_SYSCODE.Reserved]: "Reserved",
  [INVOICE_SYSCODE.Course]: "Course",
  [INVOICE_SYSCODE.Project]: "Project",
  [INVOICE_SYSCODE.Certification]: "Certification",
  [INVOICE_SYSCODE.Tech_Support]: "Tech Support",
  [INVOICE_SYSCODE.Membership]: "Membership",
};